/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { submitDataSchema } from './submitDataSchema';

export const teamCsvImportSubmitResponseSchema = z.object({
  get data() {
    return submitDataSchema;
  },
});
